import { cover, hideVisually, rem, rgba } from 'polished';
import styled from 'styled-components';

import { getAspectRatioRate } from '../../helpers';
import { IUserType } from '../../types';
import { IStyledCardList } from './CardShowcase.types';

export const StyledCardImage = styled.img`
  ${cover()}
  display: block;
  height: 100%;
  width: 100%;
  object-fit: cover;
  cursor: pointer;
  transition: transform 0.5s ease;
`;

export const StyledCard = styled.div`
  position: relative;
  width: 100%;
  padding-top: ${getAspectRatioRate(224, 317)};
  border-radius: ${rem('16px')};
  overflow: hidden;
  transform: translateZ(0);

  &:hover {
    ${StyledCardImage} {
      transform: scale(1.25);
    }
  }
`;

export const StyledCardInnerWrapper = styled.div`
  ${cover()}
`;

export const StyledCardText = styled.div<IUserType>`
  ${cover()}
  z-index: 100;
  padding: ${rem('32px')} ${rem('22px')};
  background-color: ${({ theme, user }) =>
    user && rgba(theme.colors[user].main, 0.85)};
  overflow-y: auto;

  &[aria-hidden='true'] {
    ${hideVisually()};
  }
`;

export const StyledCardInnerTitle = styled.span`
  display: block;
  margin-bottom: ${rem('32px')};
  color: ${({ theme }) => theme.colors.main};
  font-size: ${rem('20px')};
  font-weight: 300;
`;

export const StyledCardList = styled.ul<IStyledCardList>`
  display: flex;
  flex-direction: row;
  margin: 0;
  padding: 0;
  transition: transform 0.25s ease;
  transform: ${({ slideX }) => `translateX(${slideX}px)`};
`;

export const StyledCardListItem = styled.li`
  list-style: none;

  &:not(:first-child) {
    margin-left: ${rem('16px')};
  }
`;

export const StyledLink = styled.a`
  display: flex;
  align-items: center;
  color: inherit;
  text-decoration: none;
  transition: padding-left 0.25s ease-out;

  svg {
    display: block;
    height: ${rem('7px')};
    width: auto;
    margin-top: ${rem('-2px')};
    margin-left: ${rem('10px')};
    transform: rotate(-90deg);
    visibility: hidden;

    path {
      fill: ${({ theme }) => theme.colors.main};
    }
  }

  &:hover {
    padding-left: ${rem('12px')};

    svg {
      visibility: visible;
    }
  }
`;

export const StyledLinkList = styled.ul`
  margin: 0;
  padding: 0;
`;

export const StyledLinkListItem = styled.li`
  color: ${({ theme }) => theme.colors.main};
  font-size: ${rem('14px')};
  font-weight: 700;
  list-style: none;
  text-transform: uppercase;

  &:not(:first-child) {
    margin-top: ${rem('16px')};
  }
`;

export const StyledCardTitle = styled.span`
  display: flex;
  margin-top: ${rem('12px')};
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('24px')};
  font-weight: 700;
  line-height: 1.4;
`;

export const StyledNav = styled.nav`
  display: flex;
  width: 100%;
  justify-content: flex-end;

  &:not(:empty) {
    padding-bottom: ${rem('24px')};
  }
`;

export const StyledNavButton = styled.button`
  height: ${rem('24px')};
  width: ${rem('24px')};
  display: flex;
  justify-content: center;
  align-items: center;
  margin: ${rem('5px')};
  border: none;
  background: transparent;
  appearance: none;
  cursor: pointer;

  svg {
    width: ${rem('11px')};
    height: auto;
  }

  &:nth-child(1) {
    svg {
      transform: rotate(90deg);
    }
  }

  &:nth-child(2) {
    svg {
      transform: rotate(-90deg);
    }
  }

  &:focus {
    outline: none; //TODO add proper focus style
  }

  &[aria-disabled='true'] {
    opacity: 0.4;
    cursor: default;
  }
`;

export const StyledWrapper = styled.div`
  overflow: hidden;
`;
